import { render, staticRenderFns } from "./EditWorkplacePage.vue?vue&type=template&id=7f8c06bd&"
import script from "./EditWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./EditWorkplacePage.vue?vue&type=script&lang=js&"
import style0 from "./EditWorkplacePage.vue?vue&type=style&index=0&id=7f8c06bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports